/** Chart.js / ApexCharts tokens for client dashboard (light app-theme shell). */
export const CLIENT_CHART_THEME = {
  text: '#20302e',
  textMuted: '#6b7876',
  grid: 'rgba(32, 48, 46, 0.14)',
  gridLight: 'rgba(32, 48, 46, 0.08)',
  primary: '#0f6b66',
  primaryLight: '#3d8f8a',
  primaryFill: 'rgba(15, 107, 102, 0.24)',
  accent: '#fe7a59',
  accentFill: 'rgba(254, 122, 89, 0.2)',
  tooltipBg: '#ffffff',
  tooltipBorder: 'rgba(32, 48, 46, 0.12)',
  tooltipTitle: '#20302e',
  tooltipBody: '#6b7876',
  fontFamily: 'Inter, system-ui, sans-serif',
} as const;
